export function setStorage(key: string, value: string): void {
  localStorage.setItem(key, value);
}

export function getStorage(key: string): any {
  let getValue = localStorage.getItem(key);
  return getValue;
}

export function removeStorage(key: string): void {
  localStorage.removeItem(key);
}

export function clearStorage(): void {
  localStorage.clear();
}
